import { render, staticRenderFns } from "./ReviewsAndRatings.vue?vue&type=template&id=1a64575f"
import script from "./ReviewsAndRatings.vue?vue&type=script&lang=js"
export * from "./ReviewsAndRatings.vue?vue&type=script&lang=js"
import style0 from "./ReviewsAndRatings.vue?vue&type=style&index=0&id=1a64575f&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports